var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTemplate = function SvgTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#979AAF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.772 6.26h12.456c.234 0 .424-.194.424-.434V2.783c0-.24-.19-.435-.424-.435H2.772c-.234 0-.424.194-.424.435v3.043c0 .24.19.435.424.435zm.425-3.043h11.606v2.174H3.197V3.217zM2.785 14.087h5.387c.241 0 .437-.197.437-.44V7.484c0-.243-.196-.44-.437-.44H2.785c-.242 0-.437.197-.437.44v6.163c0 .243.195.44.437.44zm.437-6.163h4.513v5.283H3.222V7.924zM15.215 7.043H9.828c-.241 0-.437.198-.437.44v6.164c0 .243.196.44.437.44h5.387c.242 0 .437-.197.437-.44V7.484c0-.243-.195-.44-.437-.44zm-.437 6.164h-4.513V7.924h4.513v5.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.23V.422C18 .189 17.805 0 17.564 0H.436C.195 0 0 .19 0 .423v14.806c0 .234.195.423.436.423h17.128c.241 0 .436-.19.436-.423zm-.871-.424H.871V.846h16.258v13.96z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template.bc90870d.svg";
export { ForwardRef as ReactComponent };